import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../assets/logo_round.png";
import { BRAND_NAME, APP_VERSION } from "../../../common/constants";
import { useAuth } from "../../context/AuthContext";
import {
  FaUser,
  FaSignOutAlt,
  FaBars,
  FaTimes,
  FaChevronRight,
  FaCrown,
  FaRocket,
  FaClipboardList,
  FaLifeRing,
} from "react-icons/fa";
import "./Navbar.css";


const Navbar = () => {
  const { user, logout } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showSupportAlert, setShowSupportAlert] = useState(false);
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);

  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
    setProfileDropdownOpen(false);
  };

  const handleSupportClick = (e) => {
    if (!user) {
      e.preventDefault();
      setShowSupportAlert(true);
    }
  };

  const displayName =
    user?.name?.trim() || (user?.email ? user.email.split("@")[0] : "User");

  const getInitials = (name) =>
    name
      ?.split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();

  const hasProfileImage = Boolean(user?.picture);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setProfileDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <nav className="nav">
        {/* BRAND */}
        <div className="logo-wrap">
          <img src={logo} alt="Logo" className="logo" />
          <div className="brand-wrap">
            <h1 className="brand">{BRAND_NAME}</h1>
            <span className="brand-accent" />
          </div>
        </div>

        {/* MOBILE MENU ICON */}
        <div
          className="mobile-menu-icon"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </div>

        {/* RIGHT MENU */}
        <div className={`right-wrap ${mobileOpen ? "mobile-menu active" : ""}`}>
          <NavLink to="/">Home</NavLink>
          <NavLink to="/events">Events</NavLink>
          <NavLink to="/reviews">Reviews</NavLink>
         {user && (
         <Link to="/support" className="nav-link">
          Support
         </Link>
         )}

            {user && (
         <Link to="/referral" className="nav-link">
          Referral
         </Link>
         )}

          <NavLink to="/plans">Plans</NavLink>

          <NavLink to="/faqs">FAQs</NavLink>

          {/* ===== DESKTOP PROFILE DROPDOWN ===== */}
     {user && (
  <div className="desktop-only" ref={dropdownRef}>
    <div
      className="profile-icon"
      onClick={() => setProfileDropdownOpen(!profileDropdownOpen)}
    >
      {hasProfileImage ? (
        <img src={user.picture} alt={displayName} className="avatar" />
      ) : (
        <div className="default-avatar">{getInitials(displayName)}</div>
      )}
    </div>

    {profileDropdownOpen && (
      <div className="profile-dropdown">
        <DropdownItem icon={<FaUser />} onClick={() => navigate("/profile")}>
          Profile
        </DropdownItem>
                <DropdownItem
          icon={<FaClipboardList />}
          onClick={() => navigate("/my-active-plan")}
        >
          My Plan
        </DropdownItem>
        <DropdownItem icon={<FaCrown />} onClick={() => navigate("/plans")}>
          Go Premium
        </DropdownItem>
        <DropdownItem
          icon={<FaRocket />}
          onClick={() => navigate("/getting-started")}
        >
          Getting Started
        </DropdownItem>

        <DropdownItem icon={<FaSignOutAlt />} danger onClick={handleLogout}>
          Logout
        </DropdownItem>

        <div className="version">App Version {APP_VERSION}</div>
      </div>
    )}
  </div>
)}


          {/* ===== MOBILE ACCOUNT ===== */}
          {user && (
            <div className="mobile-account-section">
              <div className="mobile-divider" />

              <div
                className="mobile-profile"
                onClick={() => {
                  navigate("/account");
                  setMobileOpen(false);
                }}
              >
                <div className="profile-left">
                  {hasProfileImage ? (
                    <img src={user.picture} alt={displayName} className="avatar" />
                  ) : (
                    <div className="default-avatar">{getInitials(displayName)}</div>
                  )}
                  <span>{displayName}</span>
                </div>
              </div>

              <button
                className="mobile-logout-btn"
                onClick={() => {
                  setMobileOpen(false);
                  handleLogout();
                }}
              >
                <FaSignOutAlt />
                Logout
              </button>

               <div className="version">App Version {APP_VERSION}</div>
            </div>
          )}

          {/* ===== DESKTOP AUTH ===== */}
          {!user && (
            <div className="auth-actions">
              <Link to="/login" className="login-btn">
                Login
              </Link>
              <Link to="/register" className="register-btn">
                Sign Up
              </Link>
            </div>
          )}
        </div>
      </nav>

      {/* SUPPORT ALERT MODAL */}
      {showSupportAlert && (
        <div className="overlay">
          <div className="modal">
            <h3>Login Required</h3>
            <p>You need to login or register to raise a support ticket.</p>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 12 }}>
              <button className="dismiss-btn" onClick={() => setShowSupportAlert(false)}>
                Dismiss
              </button>
              <button className="register-btn" onClick={() => navigate("/register")}>
                Go to Registration
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

/* ================= REUSABLE ================= */
const NavLink = ({ to, children }) => (
  <Link to={to} className="nav-link">
    {children}
  </Link>
);

const DropdownItem = ({ icon, children, onClick, danger }) => (
  <div
    className={`dropdown-item ${danger ? "danger" : ""}`}
    onClick={onClick}
  >
    {icon}
    <span>{children}</span>
  </div>
);

export default Navbar;
